import Image from './Image'
import { OptimisedImage, OptimisedImageProps } from './OptimisedImage'
export { Image, OptimisedImage }
export type { OptimisedImageProps }
